module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAqCAMAAAAH47LZAAAAM1BMVEUAAAD///////////////////////////////////////////////////////////////+3leKCAAAAEHRSTlMAv0Ag798QX5+AcE/PsJCPXqQEngAAALRJREFUOMuNk1sOg0AMxLybLRTog/uftlWlaoQQmfh75A9HgWhjz2kBxNg9He57gQZ7iYlR3LXK7AG9spuhIrwBbDUdDKsLABa3u/NjcsIACa0OpprO3LjxJ2+9IZppXBDOYITSiflqtyKy1sGRxTSW0Ook9DqIi3880dKTiW4aS2gaS5jqxC3VifW4eyOy1sEVi2ksYaoTL82eJER+MtFMFLVWYyeUzgtnHOv3emOlQO8TJz4fjTsrYhumzgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down_white.png
// module id = upAy
// module chunks = 1